import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import Loader from "../components/loader";

/**
 * Simple layout wrapper for onboarding routes
 * This ensures onboarding routes don't use the main navbar/sidebar layout
 */
export function OnboardingLayout() {
  return (
    <Suspense fallback={<Loader />}>
      <Outlet />
    </Suspense>
  );
}

